import { AuthenticationService } from '@adgate/common/services/authentication-service';
import { DialogService } from '@adgate/common/services/dialog-service';
import { StateService } from '@adgate/common/services/state-service';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

export const RouteActivateGuard: CanActivateFn = (route, state) => 
{
  let notAuthenticatedError: string = 'User is not properly authenticated or session has expired';
  let insuficientPrivileges: string = 'You do not have the required privileges to access the module';

  let stateService: StateService = inject(StateService);
  let authService: AuthenticationService = inject(AuthenticationService);
  let dialogService: DialogService = inject(DialogService);

  stateService.restore();

  if (!authService.isUserAuthenticated()) {
    stateService.init();
    stateService.navigate("/login");
    dialogService.openErrorDialog( notAuthenticatedError );
    return false;    
  } else {
    if (route.data != undefined && route.data.hasOwnProperty('requiredPrivilege')) {
      if (!authService.checkPrivilege(route.data['requiredPrivilege'])) {
        stateService.navigate("/main");
        dialogService.hideProgress();
        dialogService.openErrorDialog( insuficientPrivileges );
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
};
